import { useQuery } from '@tanstack/react-query';
import { feedbackApi } from '../api/feedback';
import type { FeedbackListFilter } from '../types/feedback';

/**
 * GET /api/eraf/catalog/feedback — ROLE_ADMIN 전용 목록 조회.
 * queryKey: ['common-showcase', 'feedback', 'list', filters]
 */
export function useFeedbackList(filter: FeedbackListFilter) {
  return useQuery({
    queryKey: ['common-showcase', 'feedback', 'list', filter],
    queryFn: () => feedbackApi.list(filter),
    staleTime: 10_000,
  });
}
